import React, { useState } from "react";

import { useUserData } from "components/customHooks/userDataContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ButtonProgress from "components/ButtonProgress";
import { Modal } from "@mui/material";

const EncounterModal = ({
  id,
  practice_id,
  encounter_id,
  npi,
  savedNotes,
  onClose,
  updateNotes,
  categories,
  fetchedNotes,
  encounterNote,
  fetchEncounterText,
  setNoteText,
  enhanceText,
  isEnhancing,
}) => {
  const [current, setCurrentNote] = useState(categories[0]);
  const [notes, setNotes] = useState({ ...savedNotes });

  const [isSaving, setIsSaving] = useState(false);
  const [isEnhanceSaving, setIsEnhanceSaving] = useState(false);

  const userData = useUserData();

  const addTemplate = (text) => {
    if (!text) return;
    setNotes({ ...notes, [current]: notes[current] + text });
  };

  const setx = (d) => {
    console.log(d);
    setNoteText(d, encounterNote.cat);
  };

  const handleSave = async () => {
    setIsSaving(true);
    const common = {
      dictation_id: id,
      scribe_id: userData.email,
      encounter_id,
      practice_id,
      npi,
      user_name: userData.first_name + " " + userData.last_name,
    };
    let payloadNotes;
    if (fetchedNotes) {
      payloadNotes = fetchedNotes.map((n) => ({
        ...n,
        note_text: notes[n.note_category] || "",
        practice_id: userData?.selected_practice,
      }));
    } else {
      payloadNotes = categories.map((c) => ({
        ...common,
        note_category: c,
        note_text: notes[c] || "",
        practice_id: userData?.selected_practice,
      }));
    }
    if (payloadNotes.length === 0) {
      onClose();
      setIsSaving(false);
      return;
    }
    const payload = {
      type: "Scribe",
      notes: payloadNotes,
    };
    let subjective;
    let assessment;
    if (
      notes.hasOwnProperty("Subjective" || notes.hasOwnProperty("Assessment"))
    ) {
      subjective =
        notes?.["Subjective"] === savedNotes?.["savedNotes"]
          ? ""
          : notes?.["Subjective"];
      assessment =
        notes?.["Assessment"] === savedNotes?.["Assessment"]
          ? ""
          : notes?.["Assessment"];
    } else if (
      notes.hasOwnProperty("History") ||
      notes.hasOwnProperty("Recommendation")
    ) {
      subjective =
        notes?.["History"] === savedNotes?.["History"]
          ? ""
          : notes?.["History"];
      assessment =
        notes?.["Recommendation"] === savedNotes?.["Recommendation"]
          ? ""
          : notes?.["Recommendation"];
    }
    if (assessment && subjective)
      await updateNotes(payload, assessment, subjective);
    else if (subjective) await updateNotes(payload, "", subjective);
    else if (assessment) await updateNotes(payload, assessment, "");
    else await updateNotes(payload, "", "");
    setIsSaving(false);
  };

  const updateEnhanceNotes = async (type) => {
    if (type === "original") {
      setIsSaving(true);
    } else {
      setIsEnhanceSaving(true);
    }
    const updatedData = fetchedNotes.map((x) =>
      x.note_category === encounterNote.cat
        ? {
            ...x,
            note_text:
              type === "original" ? encounterNote.noteText : enhanceText,
            user_name: userData.first_name + " " + userData.last_name,
          }
        : x
    );
    const payload = {
      type: "Scribe",
      notes: updatedData,
    };
    await updateNotes(payload, "", "");
    onClose();
    setIsSaving(false);
    setIsEnhanceSaving(false);
  };
  return (
    <Modal onC1lose={() => {}} open={true}>
      <div className="dictation-notes-modal">
        <header className="dnm-header">
          <h3 className="dnm-header-title">{encounterNote.cat}</h3>
        </header>
        <main className="dnm-main">
          <div className="dnm-input-cont">
            <div className="dnm-input-div">
              {/* {categories.map((c) => ( */}
              <div style={{ display: "block" }} key={encounterNote.cat}>
                <h3
                  style={{
                    marginBottom: 10,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Original Text
                </h3>
                <ReactQuill
                  theme="snow"
                  value={encounterNote.noteText || ""}
                  // onChange={(e) => setNoteText({ ...notes, [c]: e })}
                  onChange={(e) => setx(e)}
                />
              </div>
              {/* ))} */}
            </div>
          </div>
          <header className="dnm-header">
            <div style={{ display: "flex", alignSelf: "center" }}>
              <button
                onClick={fetchEncounterText}
                className="dnm-header-template"
                style={{ marginRight: 10 }}
              >
                {isEnhancing ? (
                  <ButtonProgress size={14} color="#d91a5f" />
                ) : (
                  "Enhance"
                )}
              </button>
            </div>
          </header>
          <div className="dnm-input-cont">
            <div className="dnm-input-div">
              <h3
                style={{
                  marginBottom: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Enhance Text
              </h3>
              {/* {categories.map((c) => ( */}
              <div style={{ display: "block" }} key={encounterNote.cat}>
                <ReactQuill
                  theme="snow"
                  value={enhanceText || ""}
                  // onChange={(e) => setNotes({ ...notes, [c]: e })}
                />
              </div>
              {/* ))} */}
            </div>
          </div>
        </main>
        <header className="dnm-header">
          <div style={{ marginTop: 15 }}>
            <button
              onClick={() => updateEnhanceNotes("enhance")}
              className="dnm-header-template"
            >
              {isEnhanceSaving ? (
                <ButtonProgress size={14} color="#d91a5f" />
              ) : (
                "Retain Enhanced Text"
              )}
            </button>
            <button
              className="dnm-header-save"
              onClick={() => updateEnhanceNotes("original")}
              style={{ width: "auto" }}
            >
              {isSaving ? (
                <ButtonProgress size={14} />
              ) : (
                "Retain Updated Original Text"
              )}
            </button>
            <button className="dnm-header-cancel" onClick={onClose}>
              Close
            </button>
          </div>
        </header>
      </div>
    </Modal>
  );
};

export default EncounterModal;
